<template>
  <div>
    <div class="navbar-wrapper big">
      <a href="https://www.timeslate.com" class="timeslot-logo w-nav-brand">
        <img
          src="@/assets/timeslot-images/timeslate-logo.svg"
          loading="lazy"
          alt=""
          class="navbar1_logo"
        />
      </a>
      <!--      navbar-menu-->
      <nav
        role="navigation"
        class="navbar-menu  w-nav-menu"
        style="transform: translateY(0px) translateX(0px);"
      >
        <a
          href="https://www.timeslate.com/discover"
          class="navbar1_link w-nav-link"
          to="/discover-professionals"
          >Discover</a
        >
        <a
          href="https://www.timeslate.com/become-a-pro"
          class="navbar1_link w-nav-link"
          >Become a Professional</a
        >
        <div class="navbar1_menu-buttons">
          <div class="navbar1_button-wrapper">
            <router-link to="/login" class="login-button w-button"
              >Login</router-link
            >
          </div>
          <div class="navbar1_button-wrapper">
            <router-link to="/get-started" class="sign-up-button w-button"
              >Get Started</router-link
            >
          </div>
        </div>
      </nav>
      <div class="meu-button w-nav-button">
        <div class="menu-icon1">
          <div class="menu-icon1_line-top"></div>
          <div class="menu-icon1_line-middle">
            <div class="menu-icon_line-middle-inner"></div>
          </div>
          <div class="menu-icon1_line-bottom"></div>
        </div>
      </div>
    </div>
    <!--    style="height: 780px; display: block;"-->
    <!--    <div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0" >-->
    <!--      <nav role="navigation" class="navbar-menu w-nav-menu" style="transform: translateY(0px) translateX(0px); transition: transform 400ms ease 0s;" data-nav-menu-open="">-->
    <!--      <router-link to="/discover-professionals" class="navbar1_link w-nav-link w&#45;&#45;nav-link-open">Discover</router-link>-->
    <!--      <router-link to="/become-a-professional" class="navbar1_link w-nav-link w&#45;&#45;nav-link-open">Become a Professional</router-link>-->
    <!--      <div class="navbar1_menu-buttons">-->
    <!--        <div class="navbar1_button-wrapper">-->
    <!--          <router-link to="/login" class="login-button w-button">Login</router-link>-->
    <!--        </div>-->
    <!--        <div class="navbar1_button-wrapper">-->
    <!--          <router-link to="/sign-up" class="sign-up-button w-button">Get Started</router-link>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      </nav>-->
    <!--    </div>-->

    <!--    height: 780px; display: block;-->
    <!--    <div-->
    <!--      data-wf-ignore=""-->
    <!--      :class="cross ? 'w-nav  w-nav-overlay' : 'w-nav-overlay'"-->
    <!--      id="w-nav-overlay-0"-->
    <!--      style=""-->
    <!--      v-if="cross"-->
    <!--    >-->
    <!--      <nav-->
    <!--        role="navigation"-->
    <!--        class="navbar-menu w-nav-menu"-->
    <!--        v-if="cross"-->
    <!--        style="transform: translateY(0px) translateX(0px); transition: transform 400ms ease 0s;"-->
    <!--        data-nav-menu-open=""-->
    <!--      >-->
    <!--        <router-link-->
    <!--          to="/discover-professionals"-->
    <!--          class="navbar1_link w-nav-link w&#45;&#45;nav-link-open"-->
    <!--          >Discover</router-link-->
    <!--        >-->
    <!--        <router-link-->
    <!--          to="/become-a-professional"-->
    <!--          class="navbar1_link w-nav-link w&#45;&#45;nav-link-open"-->
    <!--          >Become a Professional</router-link-->
    <!--        >-->
    <!--        <div class="navbar1_menu-buttons">-->
    <!--          <div class="navbar1_button-wrapper">-->
    <!--            <router-link to="/login" class="login-button w-button"-->
    <!--              >Login</router-link-->
    <!--            >-->
    <!--          </div>-->
    <!--          <div class="navbar1_button-wrapper">-->
    <!--            <router-link to="/sign-up" class="sign-up-button w-button"-->
    <!--              >Get Started</router-link-->
    <!--            >-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </nav>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "LandingPageNavBar",
  data() {
    return {
      hamburger: true,
      cross: false
    };
  },
  methods: {
    showMobileMenu() {
      this.hamburger = false;
      this.cross = true;
    },
    showHamburger() {
      this.cross = false;
      this.hamburger = true;
    }
  },
  props: {
    bar: Boolean
  }
};
</script>

<style scoped>
.navbar-wrapper.big {
  min-height: 4.5rem;
}
@media only screen and (max-width: 991px) {
  .navbar-wrapper.big {
    display: none;
  }
}
</style>
